<template>
  <div class="layout_c">
    <div class="top">
      <top />
    </div>
    <!-- 内容部分 -->
    <div :class="$route.fullPath.indexOf('index') !== -1 ? 'member-right-navbar-index' : 'member-right-navbar'">
      <app-main class="main"></app-main>
    </div>
    <div class="bottom">
      <bottom />
    </div>
  </div>
</template>

<script>
import top from './top.vue'
import AppMain from './main.vue'
import bottom from './bottom.vue'
export default {
  components: {
    top,
    AppMain,
    bottom
  },
}
</script>

<style scoped>
.layout_c {
  height: 100%;
  min-width: 1200px;
  overflow: auto;
}
.member-right-navbar-index {
  width: 100%;
}
.member-right-navbar {
  padding-top: 60px;
  width: 1200px;
  margin: 0 auto;
}
</style>